"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.h = react_1.createElement;
exports.noop = function () { };
exports.T = function (key) { return key; };
exports.isClient = typeof window === 'object';
//# sourceMappingURL=util.js.map